/* Flipper Kids - Jeans banner (SUMMER GIRLS -> JEANS COLLECTION 26)
   Updated by Claude (Anthropic AI) 2026-08-03 v2 - inherits the real product-block classes so it matches sibling card size/spacing exactly, instead of a guessed aspect-ratio. Anchored right after חצאית מוניק (handle 42794). */
(function () {
  var TARGET_HANDLES = ['summer-collection-girls'];
  var ANCHOR_PRODUCT_HANDLE = '42794';
  var BANNER_IMG = 'https://cdn.shopify.com/s/files/1/0622/3790/1043/t/22/assets/fk-jeans-banner-v2.jpg';
  var BANNER_LINK = '/collections/jeans-collection-26';

  function onTarget() {
    var path = decodeURIComponent(location.pathname);
    for (var i = 0; i < TARGET_HANDLES.length; i++) {
      if (path.indexOf('/collections/' + TARGET_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  function findAnchorBlock() {
    var blocks = document.querySelectorAll('.product-block');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('a[href*="/products/' + ANCHOR_PRODUCT_HANDLE + '"]')) return blocks[i];
    }
    return null;
  }

  function insert() {
    if (!onTarget() || document.querySelector('.fk-midbanner')) return;
    var anchor = findAnchorBlock();
    if (!anchor) return;

    var b = document.createElement('div');
    b.className = anchor.className + ' fk-midbanner';

    var innerImgBox = anchor.querySelector('.hover-images, .rimage-wrapper, .product-block__image');
    var refBox = innerImgBox || anchor;

    var a = document.createElement('a');
    a.href = BANNER_LINK;
    a.style.display = 'block';
    a.style.width = '100%';
    a.style.height = '100%';

    var img = document.createElement('img');
    img.src = BANNER_IMG;
    img.loading = 'lazy';
    img.alt = 'קולקציית הגינסים - NEW COLLECTION JEANS EXTRA 10%';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.display = 'block';

    a.appendChild(img);

    if (innerImgBox) {
      var wrap = innerImgBox.cloneNode(false);
      wrap.className = innerImgBox.className;
      wrap.appendChild(a);
      b.appendChild(wrap);
    } else {
      b.style.aspectRatio = '1000 / 1500';
      b.appendChild(a);
    }

    anchor.insertAdjacentElement('afterend', b);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insert);
  } else { insert(); }
  var t = null;
  var mo = new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(insert, 400);
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();